import React, { useEffect, useState } from 'react';

export default function StepFour ({ contactDetails, quoteDetails, setQuoteDetails, setStepState, handleStartAgain }) {
	const [heading, setHeading] = useState('');
	const [description, setDescription] = useState('');

	useEffect(() => {
		const { heading, description } = contactDetails;
		setHeading(heading);
		setDescription(description);
	}, [contactDetails]);

	const handleContactDetailsInput = (e) => {
		const { value, name } = e.target;
		setQuoteDetails({ [name]: value });
	};

	const isFormValid = () => {
		const { firstName, lastName, email, contactNumber } = quoteDetails;
		const isValid = [firstName.length > 0, lastName.length > 0, email.length > 0, contactNumber.length > 0];
		const checkNumber = new RegExp(/^(\+44\s?\d{10}|0044\s?\d{10}|0\s?\d{10})?$/g);
		const numberInput = document.querySelector('input[name=contactNumber]');

		if (numberInput) {
			if (!checkNumber.test(quoteDetails.contactNumber)) {
				isValid.push(false);
				numberInput.classList.add('input-error');
			} else {
				numberInput.classList.remove('input-error');
			}
		}

		return !isValid.some((x) => x === false);
	};

	const handleShowQuoteClick = () => {
		setStepState(5);

		// axios({
		// 	method: 'post',
		// 	headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		// 	url: zapierLink,
		// 	data: quoteDetails
		// }).then(
		// 	window.location = `${thankYouPage}`
		// );
	};

	const renderStepFourMarkup = () => {
		return (
			<div className="step-four__section">
				<div className="step-four__info-container">
					<h4>{heading}</h4>
					<p>{description}</p>
					<p className="info-container__quote">£<span>XXX</span></p>
				</div>

				<form className="step-four__details-form" id="detail-form">
					<div className="step-four__details">
						<label>
							<p>First Name</p>
							<input
								type="text"
								name="firstName"
								onChange={handleContactDetailsInput}
								value={quoteDetails.firstName}
							/>
						</label>
						<label>
							<p>Last Name</p>
							<input
								type="text"
								name="lastName"
								onChange={handleContactDetailsInput}
								value={quoteDetails.lastName}
							/>
						</label>
						<label>
							<p>Email</p>
							<input
								type="text"
								name="email"
								onChange={handleContactDetailsInput}
								value={quoteDetails.email}
							/>
						</label>
						<label>
							<p>Mobile Number</p>
							<p><small>(We will text you the quote too)</small></p>
							<input
								type="telephone"
								name="contactNumber"
								onChange={handleContactDetailsInput}
								value={quoteDetails.contactNumber}
							/>
							<p className="contactNumber-error">Please enter a valid number</p>
						</label>
						<label>
							<p>Event Date</p>
							<input
								disabled
								type="text"
								value={quoteDetails.partyDate}
							/>
						</label>
					</div>
				</form>
				<button className="step-four__next-btn" type="submit" form="details-form" onClick={handleShowQuoteClick} disabled={!isFormValid()}>Send me my quote!</button>
				<button onClick={handleStartAgain} className="quote-calculator__back-btn">Start Again</button>
			</div>
		);
	};

	return (
		<div className="step-four">
			{heading.length > 0 ? (
				renderStepFourMarkup()
			) : (
				<div className="loader">
					<div className="loader-inner"></div>
					<div className="loader-triangle"></div>
				</div>
			)}
		</div>
	);
}
